// ProtectedRoute.js
import { useEffect } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { fetchProfileData } from "../utils/profile";

const ProtectedRoute = () => {
  const isAuthenticated = sessionStorage.getItem("isAuthenticated");
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) return;

    let isMounted = true;

    const verifySession = async () => {
      try {
        const data = await fetchProfileData();
        if (!isMounted) return;

        // Same logout behavior as Home.js: if the server session is gone,
        // clear local auth and send the user back to login.
        if (data && data.status === "error" && data.message === "not logged in") {
          sessionStorage.removeItem("isAuthenticated");
          sessionStorage.removeItem("authToken");
          navigate("/", { replace: true });
        }
      } catch (error) {
        // Ignore transient network errors so we don't log the user out
        // just because a request failed.
      }
    };

    verifySession();

    return () => {
      isMounted = false;
    };
  }, [isAuthenticated, navigate]);

  return isAuthenticated ? <Outlet /> : <Navigate to="/" replace />;
};

export default ProtectedRoute;
